import React from "react";
import PropTypes from "prop-types";
import Document from "../../../../assets/icons/document.png";
import "./styles.scss";

const DocumentSideBarButton = ({toggleSideBar, showSideBar}) => {
    return (
        <button className="document" onClick={() => toggleSideBar(!showSideBar)}>
            <img className="image-document" src={Document} alt=""/>
        </button>
    );
};

DocumentSideBarButton.propTypes = {
    showSideBar: PropTypes.bool,
    toggleSideBar: PropTypes.func,
};

export default DocumentSideBarButton;
